import { Route, Switch } from "react-router-dom";
// import WelfareList from "./WelfareList";
import WelfareContainer from "./Welfare";
import WelfareList from "./WelfareList";
import WelfareSimulate from "./WelfareSimulate";
import WelfareNewsList from "./News/WelfareNewsList";
import NewsContainer from "./News/WelfareNews";
import WelfareBooking from "./WelfareBooking";
import EmployeeRegistry from "./EmployeeRegistry";
import EmployeeEditPage from "./EmployeeEditPage";
import HrDocumentsList from "./HrDocuments/HrDocumentsList";
import HrDocumentEdit from "./HrDocuments/HrDocumentEdit";

const Welfares = () => {
  return (
    <>
      <Switch>
        <Route exact component={WelfareList} path="/welfares" />
        <Route exact component={WelfareList} path="/welfares/list" />
        <Route
          exact
          component={EmployeeRegistry}
          path="/welfares/employee-registry"
        />
        <Route
          exact
          component={EmployeeEditPage}
          path="/welfares/employee-registry/:id"
        />
        <Route
          exact
          component={HrDocumentsList}
          path="/welfares/hr-documents"
        />
        <Route
          exact
          component={HrDocumentEdit}
          path="/welfares/hr-documents/:id"
        />
        <Route exact component={WelfareNewsList} path="/welfares/news" />
        <Route exact component={WelfareNewsList} path="/welfares/news/list" />
        <Route
          exact
          component={NewsContainer}
          path="/welfares/news/:id/:tab?"
        />
        <Route
          exact
          component={() => <div>Categories</div>}
          path="/welfares/categories"
        />
        <Route
          exact
          component={() => <div>Ad properties</div>}
          path="/welfares/ad-properties"
        />
        <Route
          exact
          component={WelfareSimulate}
          path="/welfares/welfare-impersonate"
        />
        <Route exact component={WelfareBooking} path="/welfares/bookings" />
        <Route exact component={WelfareContainer} path="/welfares/:id/:tab?" />
      </Switch>
    </>
  );
};

export default Welfares;
